import { defineStore } from "pinia";

export const useGameStore = defineStore("useGameStore", {
    state: () => ({
        currentPage: 0,
        thoughtNumber: 0
    }),
    actions: {
        incrementCurrentPage(){
            this.currentPage++;
        },
        resetCurrentPage(){
            this.currentPage = 0;
        },
        incrementThoughtNumber(increment){
            this.thoughtNumber += increment
        }
    }
})